import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';

import { CoreUserService } from '@d-services/core/user.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { AppConstant } from '@d-constants';
import { AuthService } from '@d-services';
import { catchError, switchMap, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    // private oauthService: OAuthService,
    private authService: AuthService, // private coreUserService: CoreUserService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this.authService.getAccessToken();
    // const tenantId = this.getTenantId();
    const headers: any = {};
    if (authToken) {
      headers.WmsApiToken = authToken;
    }
    // if (tenantId) {
    //   headers.tenantId =
    //     this.coreUserService.getUserLevel().tenantId || tenantId;

    //   if (
    //     this.coreUserService.getUserLevel().companyId &&
    //     !req.url.includes('GetTenantInfo')
    //   ) {
    //     headers.companyId = this.coreUserService.getUserLevel().companyId;
    //   }

    //   // for first get user permission
    //   if (
    //     req.url.split('/')[req.url.split('/').length - 1] ===
    //     'GetUserPermissions?appCode=WMS_OP'
    //   ) {
    //     delete headers.companyId;
    //   }
    // }

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.

    const authReq = authToken ? req.clone({ setHeaders: headers }) : req;

    // send cloned request with header to the next handler.
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 419 && !req.url.includes('auth/refresh-token')) {
          return this.authService.refreshAccessToken().pipe(
            switchMap((newAccessToken) => {
              const newAuthReq = req.clone({
                setHeaders: {
                  WmsApiToken: newAccessToken,
                },
              });
              return next.handle(newAuthReq);
            }),
          );
        }
        return throwError(() => error);
      }),
    );
  }

  public getTenantId(): string {
    const curentUserInfo: any = localStorage.getItem(
      AppConstant.LocalStorageKey.DIALOGUser,
    );
    if (curentUserInfo && JSON.parse(curentUserInfo).user) {
      return JSON.parse(curentUserInfo).user['tenantId'];
    }
    return '';
  }
}
